export default "__VITE_ASSET__Yxwfl9KO__"